import { useQuery } from '@tanstack/react-query';
import type { ListParticipantBadgesResponse } from 'shared';
import { api } from '@/lib/api';
import { useAuthStore } from '@/stores/auth';

export const participantBadgeKeys = {
  all: ['badges'] as const,
  mine: (participantId: number) => ['badges', 'mine', participantId] as const,
};

/**
 * GET /api/participants/{id}/badges — every badge assignment (active and
 * revoked) for the current participant. The list screen renders revoked rows
 * too, while the certification guard filters on `revokedAt === null`.
 */
export function useMyBadges(participantId: number | undefined) {
  const { isAuthenticated, kind } = useAuthStore();
  const enabled =
    isAuthenticated &&
    kind === 'participant' &&
    typeof participantId === 'number' &&
    participantId > 0;

  return useQuery({
    queryKey:
      typeof participantId === 'number'
        ? participantBadgeKeys.mine(participantId)
        : ['badges', 'mine', 'unauthenticated'],
    queryFn: () =>
      api.get<ListParticipantBadgesResponse>(
        `/api/participants/${participantId}/badges`,
      ),
    enabled,
    staleTime: 60_000,
  });
}
